/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Resend_Invite_Button1Inputs */

const en_usermanagement_resend_invite_button1 = /** @type {(inputs: Usermanagement_Resend_Invite_Button1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-send invite`)
};

/**
* | output |
* | --- |
* | "Re-send invite" |
*
* @param {Usermanagement_Resend_Invite_Button1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_resend_invite_button1 = /** @type {((inputs?: Usermanagement_Resend_Invite_Button1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Resend_Invite_Button1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_resend_invite_button1(inputs)
});
export { usermanagement_resend_invite_button1 as "userManagement_resend_invite_button" }